import React from 'react'
import injectSheet from 'react-jss'

const LinkButton = (props) => {
  const {
    classes, disabled, external, href, text, primary, style,
  } = props

  return (
    <div
      className={`${classes.linkButtonContainer} ${disabled && 'disabled'}`}
      style={style}
    >
      <a
        className={`${classes.linkButton} ${primary && 'primary'}`}
        href={href}
        target={external ? '_blank' : '_self'}
      >
        {text}
      </a>
    </div>
  )
}

const styles = theme => ({
  linkButtonContainer: {
    padding: `0 ${theme.sizes.gutter / 2}px`,
    opacity: 1,
    cursor: 'pointer',
    transition: [
      {
        property: 'opacity',
        duration: theme.speed.fast,
      },
    ],
    '&.disabled': {
      cursor: 'auto',
      opacity: 0,
    },
  },
  linkButton: {
    verticalAlign: 'middle',
    display: 'block',
    backgroundColor: theme.colors.main_2,
    color: theme.colors.secondary_3b,
    borderColor: theme.colors.secondary_3b,
    borderWidth: '3px',
    borderStyle: 'solid',
    borderRadius: '5px',
    padding: `${theme.sizes.gutter / 4}px ${theme.sizes.gutter}px`,
    textDecoration: 'none',
    transition: [
      {
        property: 'color',
        duration: theme.speed.fast,
      },
      {
        property: 'background-color',
        duration: theme.speed.fast,
      },
    ],
    '&:hover': {
      backgroundColor: theme.colors.secondary_3b,
      color: theme.colors.main_2,
    },
    '&.primary': {
      borderColor: theme.colors.main_1,
      backgroundColor: theme.colors.main_1,
      color: theme.colors.main_2,
      '&:hover': {
        backgroundColor: theme.colors.main_2,
        color: theme.colors.main_1,
      },
    },
  },
})

export default injectSheet(styles)(LinkButton)



// WEBPACK FOOTER //
// ./src/modules/core/components/linkButton.jsx